import api from './api';

// Volume uploads (sales / sell-out + production), scoped to a budget version.
// Backed by /api/volumes (volumeController.js).
export const volumeService = {
  // Shared reference lists: customers, customerGroups, sites, stockCodes (FG).
  // The Revenue selling-price screen also uses this — it needs the same
  // finished-good SKU and customer-group lists.
  getReferenceData: async () => {
    const response = await api.get('/volumes/reference-data');
    return response.data;
  },

  // ---- Sales / sell-out volumes ----
  // Server-side filtered and capped: a full version can be millions of rows,
  // so the grid asks for the slice it is showing. `filters` is the same
  // { colId: { text, values } } shape the column popovers produce.
  // Returns { rows, limit, hasMore, total } — total is null when unfiltered.
  getSalesVolumes: async (versionId, { filters, limit, offset, scope } = {}) => {
    const response = await api.get(`/volumes/sales/${versionId}`, {
      params: {
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
        ...(scope ? { scope } : {}),
      },
    });
    return response.data;
  },
  upsertSalesVolumes: async (payload) => {
    // payload: { version_id, mode: 'overwrite'|'append'|'replace', rows: [...] }
    const response = await api.post('/volumes/sales', payload);
    return response.data;
  },
  deleteSalesVolumes: async (lineIds) => {
    const response = await api.delete('/volumes/sales', { data: { line_ids: lineIds } });
    return response.data;
  },

  // ---- Production volumes ----
  // Same contract as getSalesVolumes.
  getProductionVolumes: async (versionId, { filters, limit, offset, scope } = {}) => {
    const response = await api.get(`/volumes/production/${versionId}`, {
      params: {
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
        ...(scope ? { scope } : {}),
      },
    });
    return response.data;
  },
  upsertProductionVolumes: async (payload) => {
    const response = await api.post('/volumes/production', payload);
    return response.data;
  },
  deleteProductionVolumes: async (versionId, rows) => {
    // rows: [{ site_code, stock_code }]
    const response = await api.delete('/volumes/production', { data: { version_id: versionId, rows } });
    return response.data;
  },
};

export default volumeService;
